// eslint-disable-next-line no-unused-vars
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ButtonLoading from '../Loading/buttonLoading';

const Button = (props) => {
  const { children, isDisabled, isLoading, onClick, className, ...rest } = props;
  const classNameInternal = useMemo(() => {
    let classNameTmp = `pt-[12px] pb-[12px] border-0 active:shadow-lg rounded-[4px] bg-[#3989e3] hover:bg-[#1e75d7] text-[#ffffff] text-[14px] mt-[27px] ${className || ''}`;
    if (isDisabled || isLoading) {
      classNameTmp += ' bg-[#dbe3eb] hover:bg-[#dbe3eb] text-[#6c757d] cursor-no-drop ';
    }
    return classNameTmp;
  }, [isDisabled, isLoading, className]);

  return (
    <button
      type="button"
      className={classNameInternal}
      disabled={isDisabled || isLoading}
      {...rest}
    >
      {isLoading ? (
        <div className="flex flex-col items-center">
          <ButtonLoading width={24} height={24} fill="#FFF" />
        </div>
      )
        : props.children}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  modifier: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

Button.defaultProps = {
  className: '',
  modifier: 'primary',
  onClick: () => {},
  children: null,
  isLoading: false,
  isDisabled: false,
};

export default Button;
